import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Percent = createReactComponent("Percent", ["svg", defaultAttributes, [["line", {
  x1: "19",
  y1: "5",
  x2: "5",
  y2: "19",
  key: "18lstb"
}], ["circle", {
  cx: "6.5",
  cy: "6.5",
  r: "2.5",
  key: "1r6og4"
}], ["circle", {
  cx: "17.5",
  cy: "17.5",
  r: "2.5",
  key: "1jfk5q"
}]]]);
export default Percent;